// src/app/services/chatwoot.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

@Injectable({
  providedIn: 'root',
})
export class ChatwootService {
  private scriptElement: HTMLScriptElement | null = null;
  private widgetInitialized = false;

  constructor(
    private http: HttpClient,
    private mg2uUtils: mygolfUtils
  ) {}

  loadWidget(configUrl: string, prefillData: any) {
    console.debug('loading widget ', configUrl, prefillData);
    this.http.get<any>(configUrl).subscribe(config => {
      if (!config.enableChat) {
        this.removeWidget();
        return;
      }

      if (!this.scriptElement) {
        this.scriptElement = document.createElement('script');
        this.scriptElement.src = `${config.baseUrl}/packs/js/sdk.js`;
        this.scriptElement.async = true;
        this.scriptElement.onload = () => {
          this.initializeWidget(config.baseUrl, config.websiteToken, prefillData);
          (window as any).$chatwoot.setCustomAttributes({
            appType: 'playerV5',
            apptype: 'playerV5aaa',
            fullName: 'John Doe',
          });
        };
        document.body.appendChild(this.scriptElement);
      } else if (!this.widgetInitialized) {
        this.initializeWidget(config.baseUrl, config.websiteToken, prefillData);
      } else {
        this.initializeWidget(config.baseUrl, config.websiteToken, prefillData);
        // window.chatwootSDK?.updateUser(prefillData);
      }
    });
  }

  private initializeWidget(baseUrl: string, websiteToken: string, prefillData: any) {
    let _random = Math.floor(Math.random() * 7777) + 1;
    const _key = this.mg2uUtils.generateHashSignature(
      'hmacsha-512',
      prefillData?.custom_attributes?.playerId,
      'X1ZhgUth813cxNgjSwF88q1j'
    );
    window.chatwootSDK?.run({
      baseUrl: baseUrl,
      websiteToken: websiteToken,
      prefill: prefillData,
      hideMessageBubble: false,
      contact: {
        name: 'name name',
        email: 'name@email.com',
      },
      token: _key,
      identifier: _key,
    });
    // (window as any).$chatwoot = {
    //   welcomeTitle: 'Need help with mygolf2u?',
    //   welcomeDescription: 'We’re here to support you.',
    //   availableMessage: 'We’re online and ready to chat!',
    //   unavailableMessage: 'We’re currently offline.',
    //   identifier: prefillData?.custom_attributes?.playerId,
    // };
    // (window as any).chatwootSettings = {
    //   welcomeTitle: 'Need help with mygolf2u?',
    //   welcomeDescription: 'We’re here to support you.',
    //   availableMessage: 'We’re online and ready to chat!',
    //   unavailableMessage: 'We’re currently offline.',
    // };
    this.widgetInitialized = true;
  }

  removeWidget() {
    if (this.scriptElement) {
      document.body.removeChild(this.scriptElement);
      this.scriptElement = null;
    }

    const widgetElements = document.querySelectorAll('.woot--bubble-holder');
    widgetElements.forEach(el => el.remove());

    this.widgetInitialized = false;
  }

  toggleWidget(show: boolean) {
    const widgetEl = document.querySelector('.woot--bubble-holder') as HTMLElement;

    if (!this.widgetInitialized) return;

    if (show) {
      widgetEl?.classList.remove('cw-hide');
    } else {
      widgetEl?.classList.add('cw-hide');
    }
  }
}
